import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class ComercioExteriorCatalogoManager {

  static __values = {};

  static async boot()
  {
    let value = await Storage.get('catalogo.comercioexterior');

    const params = {
      name: 'c_ce',
      version: !!value ? value.version : '0'
    }

    let response = {};

    try {
      response = await Http.get('/api/catalogos/grupos', { params });
    } catch (error) {
      console.error(error);
    }

    if (!!response.data && response.data.length > 0) {
      value = {
        'version': response.data[0].version,
        'data': response.data
      };

      await Storage.put('catalogo.comercioexterior', value);
    }

    if (!!value) {
      for (const item of value.data) {
        ComercioExteriorCatalogoManager.__values[item.name] = item.values;
      }
    } else {
      throw new Error('Los catálogos de Comercio Exterior no están disponibles');
    }
  }

  static get(catalog, _default = null) {
    return ComercioExteriorCatalogoManager.__values[catalog] || _default;
  }

  static all() {
    return ComercioExteriorCatalogoManager.__values;
  }
}

export default ComercioExteriorCatalogoManager;